export default __webpack_public_path__ + "static/media/byoc-step4.ba60901a.svg";